export const etherscan = "https://api.etherscan.io/";

export const covalent = "https://api.covalenthq.com/";